<main role="main" class="flex flex-wrap flex-column">
  <p-toast position="top-right" key="messages"
  [style]="{ 'white-space': 'pre-line' }"></p-toast>
  <app-backend-status-notification></app-backend-status-notification>
  @if (chunkRecovery.unrecoverable(); as chunkError) {
    <app-error-card
      title="This page could not finish loading"
      subheader="Reloading did not resolve it"
      [message]="'A part of the application could not be downloaded, and reloading the page did not help. This usually clears up shortly after a new version has been deployed. ' + chunkError"
      [dismissRoute]="['/home']"
      (dismissed)="chunkRecovery.dismiss()"
    ></app-error-card>
  }
  <app-tracking-consent></app-tracking-consent>
  <p-menubar orientation="top" [model]="items" [autoDisplay]="true">
    <ng-template pTemplate="end">
      @if (!wrapSearch() && (this.userService.isAuthenticated$ | async)) {
        <app-main-menu-search
        ></app-main-menu-search>
      }
    </ng-template>
  </p-menubar>
  @if (wrapSearch() && (this.userService.isAuthenticated$ | async)) {
    <div class="flex flex-column flex-grow-1">
      <app-main-menu-search class="flex-grow-1"></app-main-menu-search>
    </div>
  }
  @if ((this.userService.isAuthenticated$ | async) === false && !this.reviewSession.reviewerMode()) {
    <div class="flex flex-column">
      <p-message [severity]="$any(this.loginMessage.severity)" [icon]="this.loginMessage.icon" [closable]="false" class="w-full mb-0">
        <span class="strong">{{ this.loginMessage.summary }}:</span>&nbsp;<span><a href="/login" rel="noopener noreferrer" title="Log In">{{ this.loginMessage.detail }}</a></span>
      </p-message>
    </div>
  }
  <div class="flex flex-column">
    @if (requiresAuth && (this.userService.isAuthenticated$ | async)) {
      <div style="width:100%">
        <router-outlet></router-outlet>
      </div>
    }
    @if (!requiresAuth) {
      <div style="width:100%">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
  <div class="flex flex-column">
    @if (requiresAuth && ((this.userService.isAuthenticated$ | async) === false)) {
      <div>
        <app-login></app-login>
      </div>
    }
  </div>
  <p-scrollTop></p-scrollTop>
</main>
<app-footer></app-footer>